var _defs, _use, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoteAppTile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "90px",
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0_4_Icons_MIB3 / 0_4_3_IconMaster / home / note_app_tile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "60.6671129%",
    y1: "15.4220779%",
    x2: "75.7919232%",
    y2: "108.715503%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3372B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E0F0A",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68,-1.9105606e-11 L68,56 L67.9908717,56.0011127 C67.7272764,63.2247926 61.7880742,69 54.5,69 C47.0441559,69 41,62.9558441 41,55.5 C41,48.0441559 47.0441559,42 54.5,42 C56.4590138,42 58.3205689,42.4172698 60.0006355,43.1677795 L60,16.305 L27,21.693 L27,64 L26.9908717,64.0011127 C26.7272764,71.2247926 20.7880742,77 13.5,77 C6.04415588,77 0,70.9558441 0,63.5 C0,56.0441559 6.04415588,50 13.5,50 C15.4590138,50 17.3205689,50.4172698 19.0006355,51.1677795 L19,22.999 L19,23 L19,8 L68,-1.9105606e-11 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "61.8071162%",
    y1: "-11.4125845%",
    x2: "81.5580997%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2718",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9251C",
    stopOpacity: 0.36909965,
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "0_4_Icons_MIB3-/-0_4_3_IconMaster-/-home-/-note_app_tile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Media",
    transform: "translate(11.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Media---Fill"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.396006337,
    fill: "#FF0000",
    style: {
      mixBlendMode: "soft-light"
    },
    xlinkHref: "#path-2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67,1.17650544 L67,55.9807749 C66.8688705,59.3251975 65.4261895,62.3328519 63.1725108,64.5030611 C60.9238266,66.6684607 57.8674137,68 54.5,68 C51.0482203,68 47.9232203,66.6008898 45.6611652,64.3388348 C43.3991102,62.0767797 42,58.9517797 42,55.5 C42,52.0482203 43.3991102,48.9232203 45.6611652,46.6611652 C47.9232203,44.3991102 51.0482203,43 54.5,43 C56.881009,43 59.1066952,43.6651715 61.0006746,44.8211651 L61.0006746,44.8211651 L60.9999722,15.1284905 L26,20.8430314 L26,63.9807749 C25.8688705,67.3251975 24.4261895,70.3328519 22.1725108,72.5030611 C19.9238266,74.6684607 16.8674137,76 13.5,76 C10.0482203,76 6.92322031,74.6008898 4.66116524,72.3388348 C2.39911016,70.0767797 1,66.9517797 1,63.5 C1,60.0482203 2.39911016,56.9232203 4.66116524,54.6611652 C6.92322031,52.3991102 10.0482203,51 13.5,51 C15.8810083,51 18.1066938,51.665171 20.0006728,52.821164 L20.0006728,52.821164 L20,8.84997482 L67,1.17650544 Z",
    id: "Media---Border",
    stroke: "url(#linearGradient-3)",
    strokeWidth: 2,
    opacity: 0.490164621
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteAppTile);
export default __webpack_public_path__ + "static/media/note_app_tile.3351f32580c82ea0f7e786daafae7b43.svg";
export { ForwardRef as ReactComponent };